import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";


import { useTranslation } from 'react-i18next';

import "./style.less";
import logo from "../../images/logo.svg";
import {useAuth} from "../../services/authServices";
import {usePlatform} from "../../context/PlatformContext";

const Footer = () => {

  const {t} = useTranslation();
  const {platform} = usePlatform();

  return (
      <div className={`Footer`}>
      <div className="container">
        <div className="Footer__container">
          <div className="Footer__container-main">
            <div>
                <img alt={"platform_logo"} src={platform.logo} />
                <p>© {platform.name} {new Date().getFullYear()}. All rights reserved</p>
            </div>
            <div className="Footer__container-main-cities">
              {platform.regions.map((region,index) => {
                return <h5 key={index}>{t("cities." + region.name)}</h5>
              })}
            </div>
          </div>

          <div className="Footer__container-links">
            <a href="/legal/privacy-policy/">{t("terms.privacy_policy")}</a>
            <a href="/legal/cookies-policy/">{t("terms.cookies_policy")}</a>
            <a href="/legal/terms-conditions/">{t("footer.terms_conditions")}</a>
          </div>
        </div>
      </div>
    </div>
  );
};


export default Footer;
